module.exports = __webpack_public_path__ + "static/media/qa_accreditation_polices_procedures.53311305.svg";